import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import Folder from './Folder';
import { LabelTree } from '../stores/appStateStore';

interface FolderMenuProps extends AppProps {
    fileIx: number,
    parent: LabelTree,
    currentFolderIx: number,
    depth: number,
    path: string,
    labelCounts: Map<string, number>
}

const FolderMenu = observer((props: FolderMenuProps) => {
    const {state, styles, fileIx, parent, currentFolderIx, depth, path, labelCounts} = props;
    const currentFolder = parent.children[currentFolderIx];
    return (
        <div>
            <Folder
                state={state}
                styles={styles} 
                fileIx={fileIx}
                name={currentFolder.label}
                path={path}
                indentationLevel={depth}
                hasChildren={currentFolder.children.length > 0}
                numberOfEmails={labelCounts.get(path + (path!==''?'/':'') + currentFolder.label)!}
                openable={currentFolder}
                iconClass={'folder-icon'}            
            />
            { currentFolder.isOpen?
                currentFolder.children.map((e, ix) => {
                    return <FolderMenu 
                        state={state}
                        styles={styles} 
                        fileIx={fileIx}
                        parent={currentFolder}
                        currentFolderIx={ix}
                        depth={depth+1}
                        path={path + (path!==''?'/':'') + currentFolder.label}
                        labelCounts={labelCounts}
                    />;
                }):
                ''
            }
        </div>
    );
});

export default FolderMenu;